<template>
	<layout-page>
		<ui-button
			class="mt-5"
			type="secondary"
			v-on:click="run"
			label="Start Test"
		/>
		<div class="mt-5" id="results"></div>
	</layout-page>
</template>
<script>
let options = require("../cropOptions");

export default {
	methods: {
		run: function () {
			const evtSource = new EventSource(
				"/cropfuture/public/price-indication/watch-price-changes-test"
			);
			evtSource.onmessage = (event) => {
				console.log(event.data);
				const newElement = document.createElement("div");
				const eventList = document.getElementById("results");
				newElement.textContent = "data: " + JSON.stringify(event.data);
				eventList.appendChild(newElement);
			};
		},
	},
};
</script>
